module.exports = __webpack_public_path__ + "img/signin.c5be12f9.jpg";